<template>
  <v-data-table
    @click:row="rowClick"
    item-key="codigo"
    single-select
    fixed-header
    height="calc(100vh - 216px)"
    :headers="headers"
    :items="produtos"
    class="elevation-1"
    :search="search"
    :items-per-page="50"
    disable-filtering
    :loading="loading"
  >
    <template v-slot:top>
      <v-toolbar flat height="64px">
        <v-toolbar-title>Produtos</v-toolbar-title>
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-toolbar>
    </template>
    <template v-slot:item.codigo="{ item }">
      <v-chip color="secondary lighten-4">{{ item.codigo }}</v-chip>
    </template>
  </v-data-table>
</template>

<script>
import api from "../api/index.js";

export default {
  data() {
    return {
      expanded: [],
      selectedId: -1,
      search: "",
      headers: [
        {
          text: "Código",
          value: "codigo",
          width: "150px"
        },
        { text: "Descrição", value: "descricao", width: "60%" },
        { text: "Estoque", value: "estoque", width: "20%" },
        { text: "Valor", value: "valor", width: "20%" }
      ],
      produtos: [],
      data: []
    };
  },
  created: function() {
    this.getData();
  },
  methods: {
    rowClick: function(item, row) {
      row.select(true);
      this.selectedId = item.codigo;
    },
    getData: function() {
      this.loading = true;
      api.getProdutos(
        data => {
          this.loading = false;
          this.produtos = data;
          this.data = data;
        },
        error => {
          this.loading = false;
        }
      );
    }
  },
  watch: {
    search: function(value) {
      if (value) {
        const temp = this.data.filter(
          item =>
            (item.codigo + item.descricao + item.valor)
              .toLowerCase()
              .indexOf(value.toLowerCase()) !== -1
        );
        this.produtos = [...temp];
      } else {
        this.produtos = [...this.data];
      }
    }
  }
};
</script>
<style>
.v-data-table {
  width: 100%;
}
.v-data-footer {
  margin-right: 0px !important;
  height: 48px;
}
.v-data-footer__select {
  display: none !important;
}
.v-data-table--fixed-header {
  border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;
}
.v-data-table td,
.v-data-table th {
  padding: 4px 16px !important;
}
tr.v-data-table__selected {
  background: rgba(0, 0, 0, 0.1) !important;
}
</style>
